import {
  CreateFirmwarePackageRequest,
  FIRMWARE_UPDATE_STEP,
  FIRMWARE_UPGRADE_STATUS,
  FirmwarePackageListResult,
} from "api/interfaces/settingsInterface.interface";
import CRC32 from "crc-32";

export const RELEASE_NOTE_TYPE = {
  CURRENT: "currentReleaseNote",
  UPDATE: "updateReleaseNote",
} as const;

export const updateStep: Record<FIRMWARE_UPGRADE_STATUS, number> = {
  [FIRMWARE_UPGRADE_STATUS.READY]: -1,
  [FIRMWARE_UPGRADE_STATUS.INIT]: 0,
  [FIRMWARE_UPGRADE_STATUS.VERIFY]: 1,
  [FIRMWARE_UPGRADE_STATUS.START]: 2,
  [FIRMWARE_UPGRADE_STATUS.PROGRESS]: 3,
  [FIRMWARE_UPGRADE_STATUS.SUCCESS]: 4,
  [FIRMWARE_UPGRADE_STATUS.FAIL]: 6,
  [FIRMWARE_UPGRADE_STATUS.COMPLETE]: 5,
};

export const updateMessage: Record<FIRMWARE_UPGRADE_STATUS, string> = {
  [FIRMWARE_UPGRADE_STATUS.INIT]: "Verifying firmware",
  [FIRMWARE_UPGRADE_STATUS.VERIFY]: "Update in starting",
  [FIRMWARE_UPGRADE_STATUS.START]: "Update in progress",
  [FIRMWARE_UPGRADE_STATUS.PROGRESS]: "Update in progress",
  [FIRMWARE_UPGRADE_STATUS.SUCCESS]: "Rebooting",
  [FIRMWARE_UPGRADE_STATUS.FAIL]: "Update failed.",
  [FIRMWARE_UPGRADE_STATUS.COMPLETE]: "Update completed successfully.",
  [FIRMWARE_UPGRADE_STATUS.READY]: "Please wait while we prepare the update",
};

export const updateErrorMsg: Record<number, string> = {
  0: "Failed to verify the firmware",
  1: "Failed to start the update",
  2: "Failed to update in progress",
  3: "Failed to update in progress",
  4: "Failed to reboot",
};

export const createEditPayload = (
  payload: CreateFirmwarePackageRequest,
  selectedRow: FirmwarePackageListResult
) => {
  const editPayload: Partial<CreateFirmwarePackageRequest> = {};
  (Object.keys(payload) as (keyof CreateFirmwarePackageRequest)[]).forEach(
    (k) => {
      if (payload[k] !== selectedRow[k as keyof FirmwarePackageListResult]) {
        (editPayload as Record<string, unknown>)[k] = payload[k];
      }
    }
  );
  return editPayload as Partial<CreateFirmwarePackageRequest>;
};

/** 파일을 읽어 CRC32 해시값을 16진수 문자열로 반환 (파일 무결성 검증용) */
export async function computeFileCrc32Hex(file: File): Promise<string> {
  const buffer = await file.arrayBuffer();
  const view = new Uint8Array(buffer);
  const signed = CRC32.buf(view);
  const unsigned = signed >>> 0;
  return unsigned.toString(16).toUpperCase();
}

export const nextStep = (
  status: FIRMWARE_UPGRADE_STATUS
): FIRMWARE_UPDATE_STEP => {
  switch (status) {
    case FIRMWARE_UPGRADE_STATUS.FAIL:
      return FIRMWARE_UPDATE_STEP.FAILED;
    case FIRMWARE_UPGRADE_STATUS.COMPLETE:
      return FIRMWARE_UPDATE_STEP.SUCCESS;
    case FIRMWARE_UPGRADE_STATUS.READY:
      return FIRMWARE_UPDATE_STEP.INTRO;
    default:
      return FIRMWARE_UPDATE_STEP.UPDATE;
  }
};
